import { PAYMENT_TYPE_MASTER } from '~/utils/api-response/settings'

// State
export const state = () => ({
  loading: false,
  paymentTypes: []
})

// Actions
export const actions = {
  // Get payment type
  getPaymentType({ commit }) {
    const response = PAYMENT_TYPE_MASTER
    commit('setPaymentType', response.data)
  }
}

// Mutations
export const mutations = {
  setLoading(state, data) {
    state.loading = data
  },
  setPaymentType(state, data) {
    state.paymentTypes = data
  }
}

// Getters
export const getters = {
  paymentTypes: state => state.paymentTypes
}
